var localForage = require('localforage');
var _ = require('lodash');
export default {
    install: function (Vue, opts) {
        let intervention_reports = {};
        intervention_reports.loading = false;  // caricamento dell'oggetto
        intervention_reports.data = [];        // l'elenco degli elementi
        intervention_reports.dataOff = []; // l'elenco degli elementi offline
        intervention_reports.page = 1;         // pagina corrente
        intervention_reports.isEndList = false;    // indica se sono alla fine della lista
        intervention_reports.isFirstList = true;   // indica se sono all'inizio della lista
        intervention_reports.customers = [];
        intervention_reports.structureDoc = [
            {
                background: 'rapporto_intervento',
                show: true,
                positions: [
                    {
                        key: 'code',
                        x: 625,
                        y: 160
                    },
                    {
                        key: 'datainizio',
                        x: 840,
                        y: 160,
                        type: 'date'
                    },
                    {
                        key: 'datafine',
                        x: 1240,
                        y: 160,
                        type: 'date'
                    },
                    {
                        key: 'customer.agency',
                        x: 600,
                        y: 225
                    },
                    {
                        key: 'customer.address',
                        x: 600,
                        y: 275
                    },
                    {
                        key: 'customer.city',
                        x: 1100,
                        y: 275
                    },
                    {
                        key: 'sede.indirizzo',
                        x: 600,
                        y: 325
                    },
                    {
                        key: 'sede.luogo',
                        x: 1100,
                        y: 325
                    },
                    {
                        key: 'macchina',
                        x: 600,
                        y: 372
                    },
                    {
                        key: 'macchinanum',
                        x: 980,
                        y: 372
                    },
                    {
                        key: 'trasporto',
                        x: 980,
                        y: 419
                    },
                    {
                        key: 'current_user',
                        x: 600,
                        y: 419
                    },
                    {
                        key: 'ordine1',
                        x: 550,
                        y: 225,
                        type: 'check'
                    },
                    {
                        key: 'ordine2',
                        x: 550,
                        y: 246,
                        type: 'check'
                    },
                    {
                        key: 'ordine3',
                        x: 550,
                        y: 269,
                        type: 'check'
                    },
                    {
                        key: 'ordine4',
                        x: 550,
                        y: 292,
                        type: 'check'
                    },
                    {
                        key: 'ordine5',
                        x: 550,
                        y: 311,
                        type: 'check'
                    },
                    {
                        key: 'ordine6',
                        x: 550,
                        y: 334,
                        type: 'check'
                    },
                    {
                        key: 'ordine7',
                        x: 550,
                        y: 355,
                        type: 'check'
                    },
                    {
                        key: 'varie',
                        x: 640,
                        y: 490,
                        maxwidth: 55
                    },
                    {
                        key: 'annotazioni',
                        x: 110,
                        y: 420,
                        maxwidth: 28
                    },
                    {
                        key: 'note_cliente',
                        x: 125,
                        y: 1072,
                        maxwidth: 85
                    },
                    {
                        key: 'numddt',
                        x: 550,
                        y: 590,
                        type: 'check'
                    },
                    {
                        key: 'jsm',
                        x: 200,
                        y: 600
                    },
                    {
                        key: 'reso',
                        x: 550,
                        y: 632,
                        type: 'check'
                    },
                    {
                        key: 'garanzia',
                        x: 550,
                        y: 654,
                        type: 'check'
                    },
                    {
                        key: 'fatturare',
                        x: 550,
                        y: 676,
                        type: 'check'
                    },
                    {
                        key: 'contratto_manuntenzione',
                        x: 550,
                        y: 697,
                        type: 'check'
                    },
                    {
                        key: 'manutenzionenum',
                        x: 200,
                        y: 710
                    },
                    {
                        key: 'lun_viaggio',
                        x: 335,
                        y: 1215,
                        type: 'number'
                    },
                    {
                        key: 'mar_viaggio',
                        x: 430,
                        y: 1215,
                        type: 'number'
                    },
                    {
                        key: 'mer_viaggio',
                        x: 525,
                        y: 1215,
                        type: 'number'
                    },
                    {
                        key: 'gio_viaggio',
                        x: 610,
                        y: 1215,
                        type: 'number'
                    },
                    {
                        key: 'ven_viaggio',
                        x: 710,
                        y: 1215,
                        type: 'number'
                    },
                    {
                        key: 'sab_viaggio',
                        x: 800,
                        y: 1215,
                        type: 'number'
                    },
                    {
                        key: 'dom_viaggio',
                        x: 890,
                        y: 1215,
                        type: 'number'
                    },
                    {
                        key: 'lun_lavoro',
                        x: 335,
                        y: 1240,
                        type: 'number'
                    },
                    {
                        key: 'mar_lavoro',
                        x: 430,
                        y: 1240,
                        type: 'number'
                    },
                    {
                        key: 'mer_lavoro',
                        x: 525,
                        y: 1240,
                        type: 'number'
                    },
                    {
                        key: 'gio_lavoro',
                        x: 610,
                        y: 1240,
                        type: 'number'
                    },
                    {
                        key: 'ven_lavoro',
                        x: 710,
                        y: 1240,
                        type: 'number'
                    },
                    {
                        key: 'sab_lavoro',
                        x: 800,
                        y: 1240,
                        type: 'number'
                    },
                    {
                        key: 'dom_lavoro',
                        x: 890,
                        y: 1240,
                        type: 'number'
                    },
                    {
                        key: 'lun_km',
                        x: 335,
                        y: 1268,
                        type: 'number'
                    },
                    {
                        key: 'mar_km',
                        x: 430,
                        y: 1268,
                        type: 'number'
                    },
                    {
                        key: 'mer_km',
                        x: 525,
                        y: 1268,
                        type: 'number'
                    },
                    {
                        key: 'gio_km',
                        x: 610,
                        y: 1268,
                        type: 'number'
                    },
                    {
                        key: 'ven_km',
                        x: 710,
                        y: 1268,
                        type: 'number'
                    },
                    {
                        key: 'sab_km',
                        x: 800,
                        y: 1268,
                        type: 'number'
                    },
                    {
                        key: 'dom_km',
                        x: 890,
                        y: 1268,
                        type: 'number'
                    },
                    {
                        key: 'now',
                        x: 170,
                        y: 1335
                    },
                    {
                        key: 'now',
                        x: 170,
                        y: 1400
                    },
                    {
                        key: 'signature',
                        x: 850,
                        y: 1300
                    },
                    {
                        key: 'current_user',
                        x: 200,
                        y: 1298
                    }
                ]
            },
            {
                background: 'ddt',
                show: 'numddt',
                positions: [
                    {
                        key: 'code_type',
                        x: 70,
                        y: 30.2,
                        type: 'agency'
                    },
                    {
                        key: 'jsm',
                        x: 920,
                        y: 210
                    },
                    {
                        key: 'now',
                        x: 1240,
                        y: 210
                    },
                    {
                        key: 'customer.agency',
                        x: 80,
                        y: 340
                    },
                    {
                        key: 'customer.address',
                        x: 80,
                        y: 390
                    },
                    {
                        key: 'customer.city',
                        x: 80,
                        y: 435
                    },
                    {
                        key: 'sede.indirizzo',
                        x: 820,
                        y: 390
                    },
                    {
                        key: 'sede.customer',
                        x: 820,
                        y: 335
                    },
                    {
                        key: 'sede.luogo',
                        x: 820,
                        y: 435
                    },
                    {
                        key: 'sede.vat_number',
                        x: 820,
                        y: 480
                    },
                    {
                        key: 'customer.vat_number',
                        x: 80,
                        y: 480
                    },
                    {
                        key: 'products',
                        x: 80,
                        y: 600,
                        yspace: 20,
                        type: 'products'
                    },
                    {
                        key: 'causale',
                        x: 810,
                        y: 1290
                    },
                    {
                        key: 'current_user',
                        x: 810,
                        y: 1340
                    },
                    {
                        key: 'signature',
                        x: 870,
                        y: 1350
                    }
                ]
            }
        ]
        Vue.mixin({
            mounted() {
                /**
                 * Ritorna un singolo
                 * @param id
                 * @returns {Promise<unknown>}
                 */
                intervention_reports.getSingle = (id) => {
                    return new Promise((resolve, reject) => {
                        intervention_reports.loading = true;
                        let params = {};
                        this.api.get(`/intervention_reports/${id}`, params, true)
                            .then((result) => {
                                if (result && result.success) {
                                    resolve(result.data);
                                }
                                reject(null);
                            })
                            .catch(() => {
                                reject(null);
                            })
                            .finally(() => {
                                intervention_reports.loading = false;
                            });
                    });
                };
                /**
                 * Salvataggio
                 * @param data
                 * @param id
                 * @returns {Promise<unknown>}
                 */
                intervention_reports.save = (data, id) => {
                    return new Promise((resolve, reject) => {
                        id = (id.toString().toLowerCase().trim() === 'new') ? null : id;
                        let call = null;
                        if (id == null) {
                            call = this.api.post(`/intervention_reports`, data, false);
                        } else {
                            call = this.api.put(`/intervention_reports/${id}`, data, false);
                        }
                        call.then((result) => {
                            if (result && result.success) {
                                resolve(true);
                            }
                            reject(null);
                        })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                };
                intervention_reports.delete = (id) => {
                    return new Promise((resolve, reject) => {
                        this.api.delete(`/intervention_reports/${id}`, false).then((result) => {
                            if (result && result.success) {
                                resolve(true);
                            }
                            reject(null);
                        })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                }
                /**
                 * DDTY
                 */
                intervention_reports.ddt = {
                    getNext: (agency) => {
                        agency = agency || "service";
                        return new Promise((resolve, reject) => {
                            this.api.get(`/intervention_reports/getLastDDT?agency=${agency}`, {},false).then((result) => {
                                if (result && result.success) {
                                    resolve(result.data.next);
                                }
                                reject(null);
                            }).catch((error) => {
                                reject(error);
                            });
                        });
                    },
                    check: (ddt, agency) => {
                        ddt = ddt.replace(/\//g, '|');
                        agency = agency || "service";
                        return new Promise((resolve, reject) => {
                            this.api.get(`/intervention_reports/checkDDT/${ddt}?agency=${agency}`, false).then((result) => {
                                if (result && result.success) {
                                    resolve(result.data);
                                }
                                reject(null);
                            }).catch((error) => {
                                reject(error);
                            });
                        });
                    }
                }

                intervention_reports.code = {
                    getNext: () => {
                        return new Promise((resolve, reject) => {
                            this.api.get(`/intervention_reports/getLastCode`, {},false).then((result) => {
                                if (result && result.success) {
                                    resolve(result.data.next);
                                }
                                reject(null);
                            }).catch((error) => {
                                reject(error);
                            });
                        });
                    },
                    check: (code) => {
                        code = code.replace(/\//g, '|');
                        return new Promise((resolve, reject) => {
                            this.api.get(`/intervention_reports/checkCode/${code}`, false).then((result) => {
                                if (result && result.success) {
                                    resolve(result.data);
                                }
                                reject(null);
                            }).catch((error) => {
                                reject(error);
                            });
                        });
                    }
                }

                /**
                 * Lista degli utenti
                 */
                intervention_reports.getList = (searchText) => {
                    searchText = searchText || '';
                    intervention_reports.loading = true;
                    let params = {
                        page: intervention_reports.page,
                        search: searchText
                    };
                    this.api.get('/intervention_reports', params, true)
                        .then((result) => {
                            intervention_reports.data = [];
                            for (var key in result.data) {
                                intervention_reports[key] = result.data[key];
                            }
                            intervention_reports.isFirstList = true;
                            intervention_reports.isEndList = false;
                            if (intervention_reports.page !== 1) {
                                intervention_reports.isFirstList = false;
                                intervention_reports.isEndList = false;
                            }
                            if (intervention_reports.page == intervention_reports.pages) {
                                intervention_reports.isEndList = true;
                                intervention_reports.isFirstList = false;
                            }
                        })
                        .finally(() => {
                            intervention_reports.loading = false;
                        });
                };
                /**
                 * Prende i dati della pagina successiva
                 */
                intervention_reports.nextPage = () => {
                    if (intervention_reports.page < intervention_reports.pages) {
                        intervention_reports.page = intervention_reports.page + 1;
                        intervention_reports.getList();
                    }
                };
                /**
                 * Prende i dati della pagina precendente
                 */
                intervention_reports.prevPage = () => {
                    if (intervention_reports.page > 1) {
                        intervention_reports.page = intervention_reports.page - 1;
                        intervention_reports.getList();
                    }
                };
                /**
                 * Prende i dati della prima pagina
                 */
                intervention_reports.firstPage = () => {
                    intervention_reports.page = 1;
                    intervention_reports.getList();
                };
                /**
                 * Prende i dati dell'ultima pagina
                 */
                intervention_reports.lastPage = () => {
                    intervention_reports.page = intervention_reports.pages;
                    intervention_reports.getList();
                };
                /**
                 * Prende i dati di una pagina prefissata
                 * @param page
                 */
                intervention_reports.goPage = (page) => {
                    if (page > 0 && page <= intervention_reports.pages) {
                        intervention_reports.page = page;
                        intervention_reports.getList();
                    }
                };
                let offlineMethods = {};
                offlineMethods.buildOfflineData = (page, pageSize, seachText) => {
                    return new Promise(resolve => {
                        let offset = (page - 1) * pageSize;
                        let tmp = {
                            page: page,
                            total: intervention_reports.dataOff.length,
                            pages: Math.ceil(intervention_reports.dataOff.length / pageSize),
                            data: _.drop(intervention_reports.dataOff, offset).slice(0, pageSize)
                        };
                        let result = [];
                        if(tmp.data.length <= 0) {
                            resolve(tmp);
                        }
                        if (intervention_reports.customers == null || intervention_reports.customers.length <= 0) {
                            localForage.getItem('customers')
                                .then((customers) => {
                                    intervention_reports.customers = customers;
                                    tmp.data.map(item => {
                                        let c = _.filter(intervention_reports.customers, (c) => {
                                            return c.id == item.customer_id;
                                        });
                                        item.customer = {};
                                        if (c && c.length > 0)
                                            item.customer = c.pop();
                                        result.push(item);
                                    });
                                    resolve(tmp);
                                })
                                .catch(() => {
                                    resolve(tmp);
                                });
                        } else {
                            tmp.data.map(item => {
                                let c = _.filter(intervention_reports.customers, (c) => {
                                    return c.id == item.customer_id;
                                });
                                // console.log(c, 'else', intervention_reports.customers);
                                item.customer = {};
                                if (c && c.length > 0)
                                    item.customer = c.pop();
                                result.push(item);
                            });
                            tmp.data = result;
                            resolve(tmp);
                        }
                    });
                };
                /**
                 * Prende la lista dei clienti offline
                 * @param page
                 * @param pageSize
                 * @param seachText
                 * @returns {Promise<unknown>}
                 */
                offlineMethods.get = (page, pageSize, seachText) => {
                    return new Promise((resolve, reject) => {
                        intervention_reports.dataOff = [];
                        if (intervention_reports.dataOff.length <= 0) {
                            // non ci sono dati e quindi li prendo dallo storage la prima volta
                            localForage.getItem('intervention_reports')
                                .then((data) => {
                                    data = (data == null) ? [] : data;
                                    data.map(item => {
                                        intervention_reports.dataOff.push(item);
                                    });
                                    intervention_reports.dataOff = _.orderBy(intervention_reports.dataOff, ['updated_at'], ['desc']);
                                    resolve(intervention_reports.offline.buildOfflineData(page, pageSize, seachText))
                                })
                                .catch(() => {
                                    resolve([]);
                                })
                        } else {
                            resolve(intervention_reports.offline.buildOfflineData(page, pageSize, seachText))
                        }
                    });
                };
                /**
                 * Inserisce un cliente al database
                 * @param customer
                 * @returns {Promise<unknown>}
                 */
                offlineMethods.add = (customer) => {
                    return new Promise((resolve, reject) => {
                        let customersData = [];
                        localForage.getItem('intervention_reports')
                            .then((data) => {
                                data = (data == null) ? [] : data;
                                data.map(item => {
                                    customersData.push(item);
                                });
                                customersData.push(customer);
                                localForage.setItem('intervention_reports', customersData, (err, value) => {
                                    if (err == null) {
                                        resolve(customer.id);
                                    }
                                    reject(err);
                                    intervention_reports.customers = [];
                                });
                            })
                            .catch((err) => {
                                reject(err)
                            })
                    });
                };
                intervention_reports.offline = offlineMethods;
            }
        });
        Vue.prototype.api.intervention_reports = intervention_reports;
    }
}
